import api from './api';

/**
 * Get all festivals
 * @param {Object} params - Query parameters (search, month)
 * @returns {Promise<Object>} Response with festivals data
 */
export const getFestivals = async (params = {}) => {
  const response = await api.get('/admin/festivals', { params });
  return response.data;
};

/**
 * Get a single festival by ID
 * @param {number} id - Festival ID
 * @returns {Promise<Object>} Festival object
 */
export const getFestivalById = async (id) => {
  const response = await api.get(`/admin/festivals/${id}`);
  return response.data;
};

/**
 * Create a new festival
 * @param {Object} data - Festival data
 * @returns {Promise<Object>} Created festival
 */
export const createFestival = async (data) => {
  const response = await api.post('/admin/festivals', data);
  return response.data;
};

/**
 * Update a festival
 * @param {number} id - Festival ID
 * @param {Object} data - Festival data
 * @returns {Promise<Object>} Updated festival
 */
export const updateFestival = async (id, data) => {
  const response = await api.put(`/admin/festivals/${id}`, data);
  return response.data;
};

/**
 * Delete a festival
 * @param {number} id - Festival ID
 * @returns {Promise<Object>} Deletion result
 */
export const deleteFestival = async (id) => {
  const response = await api.delete(`/admin/festivals/${id}`);
  return response.data;
};

const festivalsService = {
  getFestivals,
  getFestivalById,
  createFestival,
  updateFestival,
  deleteFestival
};

export default festivalsService;
